import Layouts from '../../layouts/Layouts';
import { FindDoctorFilter } from '../../Components/Forms';
import { SectionHeading } from '../../Components/SectionHeading';
import './doctorListing.css';

function DoctorListing() {
  return (
    <Layouts>
      <section className="doctorListing">
        <SectionHeading colorHeading="786" heading=" Dermatologist available" />
        <FindDoctorFilter />
      </section>
    </Layouts>
  );
}

export default DoctorListing;
